import React, { useCallback } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { useSelector } from "react-redux";

import { Translation as T, useTranslation } from "@awe-web/shared/lib";
import { Button } from "../../components/form.js";
import { SelectedTime } from "./station.js";
import { getFormattedCiDateTime, getFormattedCoDateTime } from "../store.js";

import "./selected_period.scss";
import { useLocation, useNavigate } from "react-router-dom";

const CHANGE_VALUES = "ALG0000025";
const CHECK_OUT_DATE = "ALG0000023";
const CHECK_IN_DATE = "ALG0000024";

function MinimalSelectedPeriod() {

  const formattedCoDateTime = useSelector((state) => getFormattedCoDateTime(state));
  const formattedCiDateTime = useSelector((state) => getFormattedCiDateTime(state));

  return (
    <div className="minimal-selected-period">
      <div><T className="minimal-selected-period__label" code={CHECK_OUT_DATE} /> {formattedCoDateTime}</div>
      <div><T className="minimal-selected-period__label" code={CHECK_IN_DATE} /> {formattedCiDateTime}</div>
    </div>
  );
}

function SelectedPeriodWithIcons() {

  const { translate } = useTranslation();
  const formattedCoDateTime = useSelector((state) => getFormattedCoDateTime(state));
  const formattedCiDateTime = useSelector((state) => getFormattedCiDateTime(state));

  const coDateTimeLabel = translate(CHECK_OUT_DATE);
  const ciDateTimeLabel = translate(CHECK_IN_DATE);

  return (
    <div className="selected-period-with-icons selected-period__4-of-8-cols">
      <SelectedTime
        className="selected-period-with-icons__selected-time"
        label={coDateTimeLabel}
        formattedDateTime={formattedCoDateTime}
      />
      <SelectedTime
        className="selected-period-with-icons__selected-time"
        label={ciDateTimeLabel}
        formattedDateTime={formattedCiDateTime}
      />
    </div>
  );
}

export default function SelectedPeriod({ className, editButtonLocation }) {
  const combinedClassName = classnames("selected-period", className);
  const location = useLocation();
  const navigate = useNavigate();

  const onBackClickHandler = useCallback(() => {
    navigate(editButtonLocation, { state: { from: location } });
  }, [navigate, editButtonLocation, location]);


  const editButton = editButtonLocation
    ? (
      <Button
        className="selected-period__2-of-8-cols"
        secondary
        back
        onClick={onBackClickHandler}
      >
        <T code={CHANGE_VALUES} />
      </Button>
    )
    : null;

  return (
    <div className={combinedClassName}>
      <MinimalSelectedPeriod />

      <div className="selected-period__selected-times">
        <SelectedPeriodWithIcons />
        {editButton}
      </div>
    </div>
  );
}

SelectedPeriod.propTypes = {
  className: PropTypes.string,
  editButtonLocation: Button.propTypes.to,
};
